import { reskinStyles } from './theme-variant';

export const actionUnderline = (theme) =>
  reskinStyles(theme, {
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: -3,
      height: 2,
      backgroundColor: 'currentColor',
      transform: 'scaleX(0)',
      transformOrigin: 'left',
      transition: 'transform var(--motion-duration-feedback, 0ms) var(--motion-ease-out, ease-out)',
      pointerEvents: 'none'
    },
    '@media (hover: hover) and (pointer: fine)': {
      // Attribute match: Mui* class names get numeric suffixes under a nested ThemeProvider.
      ':root[data-motion="on"][data-input="pointer"] [class*="MuiButtonBase-root"]:hover:not(:disabled) &::after': {
        transform: 'scaleX(1)'
      }
    },
    '@media (prefers-reduced-motion: reduce)': { '&::after': { transform: 'scaleX(0) !important' } }
  });
